export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/face-mesh-edit-worker.ca509aa3f20674857b94.worker.js");
}
